import { AXIOS_DEFAULT_CONFIG } from "../../constants";

/**
 * Axios config for a seat mutation.
 *
 * A host who followed the emailed link has no session, so the table's manage
 * token travels as X-Table-Token. An authenticated host sends no token and
 * relies on the session cookie. The backend accepts either, so this is the one
 * place the header is built and callers never think about it.
 */
export const tableTokenConfig = (token) =>
  token
    ? {
        ...AXIOS_DEFAULT_CONFIG,
        headers: { "X-Table-Token": token },
      }
    : AXIOS_DEFAULT_CONFIG;
